import { logger } from '@parrot-software/observability';

import { isApiErrorResponse, isAxiosError } from '@personnel/application/errors';

/**
 * Domain logger for the personnel flows.
 *
 * It carries no subdomain: this is the one domain of the catalog that declares no subdomain table,
 * so inventing one would leave the catalog behind.
 *
 * Nothing logged here may carry an email, a phone number or a PIN, not whole and not truncated.
 */
export const perLog = logger.forDomain('PER');

/**
 * Observability attributes for any thrown value.
 *
 * `error.kind` reads `name` and never `constructor.name`, which production builds rename to a
 * single letter. `error.code` carries the wire code when the backend sent one, because that is what
 * makes a front-end failure findable in the backend logs.
 */
export const errorAttributes = (error: unknown): { 'error.kind': string; 'error.code'?: string } => {
  if (!(error instanceof Error)) {
    return { 'error.kind': 'Unknown' };
  }

  const kind = error.name && error.name.length > 0 ? error.name : 'Error';
  const payload = isAxiosError(error) ? error.response?.data : undefined;
  const code = isApiErrorResponse(payload) ? payload.errors[0].code : undefined;

  return { 'error.kind': kind, ...(code ? { 'error.code': code } : {}) };
};
